// Ensure a date string is treated as UTC by appending 'Z' if no timezone indicator is present.
const asUTC = (s) => {
  if (!s) return s;
  if (/[Zz+\-]\d{0,4}:?\d{0,2}$/.test(s)) return s;
  return s + 'Z';
};

export const calculateImpactTime = (created, endTime) => {
  if (!created || !endTime) return null;
  const diffMs = new Date(asUTC(endTime)) - new Date(asUTC(created));
  if (diffMs <= 0) return null;
  const totalMinutes = Math.floor(diffMs / 60000);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  if (hours >= 24) {
    const days = Math.floor(hours / 24);
    const remHours = hours % 24;
    return `${days}d ${remHours}h ${minutes}m`;
  }
  return `${hours}h ${minutes}m`;
};

export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString || dateTimeString === "0001-01-01T00:00:00Z") {
    return 'Ongoing';
  }
  try {
    const date = new Date(asUTC(dateTimeString));
    if (isNaN(date)) {
      return 'Not available';
    }
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: 'UTC',
      timeZoneName: 'short',
    });
  } catch (error) {
    return 'Not available';
  }
};
